import script from "./SelectLayoutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectLayoutModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectLayoutModal.vue?vue&type=style&index=0&id=5b3e086c&lang=css"

const __exports__ = script;

export default __exports__